'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var card = {
  bg: 'white',
  display: 'flex',
  flexDirection: 'column',
  wordWrap: 'break-word',
  backgroundClip: 'border-box',
  boxShadow: 'sm',
  border: 1,
  borderStyle: 'solid',
  borderColor: 'gray.100',
  borderRadius: 'base'
};
exports["default"] = card;